function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPayments = function SvgPayments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 5v14m3.333-12h-5c-.619 0-1.212.263-1.65.732A2.6 2.6 0 0 0 8 9.5c0 .663.246 1.299.683 1.768a2.26 2.26 0 0 0 1.65.732h3.334c.619 0 1.212.263 1.65.732.437.47.683 1.105.683 1.768s-.246 1.299-.683 1.768a2.26 2.26 0 0 1-1.65.732H8m14-5c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10"
  }));
};
export default SvgPayments;